import 'material-icons/iconfont/material-icons.css' //Material Icons
import 'vuesax/dist/vuesax.css' // Vuesax
// Styles: SCSS
import '@/assets/scss/main.scss'
// Tailwind
import '@/assets/css/main.css'
// PrismJS
import 'prismjs'
import 'prismjs/themes/prism-tomorrow.css'
// Feather font icon
require('@/assets/css/iconfont.css')

import {themeConfig} from '@/constants/config'

import Vue from 'vue'

// Vuesax Component Framework
import Vuesax from 'vuesax'
import {colors} from '@/constants/config'
Vue.use(Vuesax, { theme:{ colors }, rtl: themeConfig.rtl })

// Clipboard
import VueClipboard from 'vue-clipboard2'
Vue.use(VueClipboard)

// Tour
import VueTour from 'vue-tour'
Vue.use(VueTour)
require('vue-tour/dist/vue-tour.css')

// Vuejs - Vue wrapper for hammerjs
import {VueHammer} from 'vue2-hammer'
Vue.use(VueHammer)

// Vuejs - Vue Thailand Address
import VueThailandAddress from 'vue-thailand-address';
Vue.use(VueThailandAddress)
require('vue-thailand-address/dist/vue-thailand-address.css')
